module.exports = __webpack_public_path__ + "static/images/icon-playstation.a750efd12c6415eca12a16015f187949.svg";